// extracted by mini-css-extract-plugin
export var readonly = "_id-1";
export var star = "_id-0";